import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
import { FIB } from "../../config/constants";
var POST_NAVIGATION_DELAY = FIB.POST_NAVIGATION_DELAY;
export default {
  name: 'TeamMemberReceiptPinEntry',
  components: {
    FibBackButton: require('@/components/BackButton').default
  },
  props: {},
  data: function data() {
    return {
      error: '',
      pinNumber: '',
      pinMask: 'XXX-XXX-XXX',
      pinMasks: ['XXX-XXX-XXX', 'XXX-XXX-XXX-XXX']
    };
  },
  computed: {
    eposData: sync('checkIn/eposData'),
    digitalReceiptAvailable: get('checkIn/digitalReceiptAvailable'),
    transactionRef: sync('checkIn/transactionRef'),
    hasConnectivity: get('settings/hasConnectivity')
  },
  watch: {
    // Watch the pin number to switch between the appropriate pin masks.
    pinNumber: function pinNumber(val) {
      var _replace;

      var noDashValLength = (_replace = (val || '').replace(/(-)/g, '')) === null || _replace === void 0 ? void 0 : _replace.length;

      if (noDashValLength === 0) {
        return;
      } // filter the pinmasks if they are still able to apply to the length of the string,
      // Once filtered take the first one and apply it as these are now sorted by length.


      this.pinMask = this.pinMasks.filter(function (pm) {
        // Strip out the dashes so we get a true string length
        var pinMaskStripped = pm.replace(/(-)/g, '');
        return pinMaskStripped.length >= noDashValLength;
      })[0];
    }
  },
  mounted: function mounted() {
    this.transactionRef = null;
  },
  methods: {
    resetPinMasks: function resetPinMasks() {
      this.pinMask = this.pinMasks[0];
      this.pinNumber = '';
    },
    noCode: function noCode() {
      var _this = this;

      this.$store.commit('app/SET_PAGE_LOADING', true);
      setTimeout(function () {
        _this.$store.commit('checkIn/resetState');

        _this.$router.push('/check_in/get_started');
      }, POST_NAVIGATION_DELAY);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit('app/SET_PAGE_LOADING_TYPE', 'pin-entry');

                _this2.$store.commit('app/SET_PAGE_LOADING', true);

                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var res;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this2.error = '';
                          _this2.transactionRef = _this2.pinNumber;

                          if (_this2.hasConnectivity) {
                            _context.next = 5;
                            break;
                          }

                          _this2.$router.push('/check_in/get_started');

                          return _context.abrupt("return");

                        case 5:
                          _context.next = 7;
                          return _this2.$store.dispatch('checkIn/fetchTransactionData');

                        case 7:
                          res = _context.sent;

                          if (!(res || {}).error) {
                            _context.next = 13;
                            break;
                          }

                          _this2.$store.commit('app/SET_PAGE_LOADING', false);

                          _this2.$store.commit('app/SET_PAGE_LOADING_TYPE', '');

                          _this2.error = res.error;
                          return _context.abrupt("return");

                        case 13:
                          Logger.debug('epos data available'); // check if digital receipt available

                          if (!_this2.digitalReceiptAvailable) {
                            _context.next = 20;
                            break;
                          }

                          // digital receipt available, redirect to digital receipt and return
                          Logger.debug('digital receipt available, redirecting to digital receipt');

                          _this2.$router.push('/check_in/digital_receipt');

                          return _context.abrupt("return");

                        case 20:
                          // digital receipt NOT available, redirect to get started and return
                          Logger.debug('digital receipt NOT available, redirecting to get started');

                          _this2.$router.push('/check_in/get_started');

                          return _context.abrupt("return");

                        case 23:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), POST_NAVIGATION_DELAY);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};